import { IWorkflowFormTemplateState } from '@/store/workflow-form-template';
import { IWorkflowFormTemplateRevisionMutations } from './mutations.types';
import {
  IWorkflowFormFieldData,
  IWorkflowFormFieldOptionTodoData,
  IWorkflowFormFieldOptionTodoTemplateData,
  IWorkflowFormTemplateData,
  IWorkflowFormTemplateRevisionData,
  IWorkflowStateData,
  IUserData
} from '@/models';

export const mutations: IWorkflowFormTemplateRevisionMutations = {
  SET_WORKFLOW_FORM_TEMPLATES_WITH_PUBLISHED_REVISIONS(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormTemplateData[]
  ): void {
    state.workflowFormTemplatesWithPublishedRevisions = payload;
  },

  UPSERT_WORKFLOW_FORM_TEMPLATE_WITH_PUBLISHED_REVISIONS(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormTemplateData
  ): void {
    const index = state.workflowFormTemplatesWithPublishedRevisions.findIndex(
      (v: IWorkflowFormTemplateData) => v.id === payload.id
    );

    if (index === -1) {
      state.workflowFormTemplatesWithPublishedRevisions.push(payload);
    } else {
      state.workflowFormTemplatesWithPublishedRevisions.splice(
        index,
        1,
        payload
      );
    }
  },

  SET_WORKFLOW_FORM_TEMPLATES(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormTemplateData[]
  ): void {
    state.workflowFormTemplates = payload;
  },

  UPSERT_WORKFLOW_FORM_TEMPLATE(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormTemplateData
  ): void {
    const index = state.workflowFormTemplates.findIndex(
      (v: IWorkflowFormTemplateData) => v.id === payload.id
    );

    if (index === -1) {
      state.workflowFormTemplates.push(payload);
    } else {
      state.workflowFormTemplates.splice(index, 1, payload);
    }
  },

  REMOVE_WORKFLOW_FORM_TEMPLATE(
    state: IWorkflowFormTemplateState,
    payload: number
  ): void {
    const index = state.workflowFormTemplates.findIndex(
      (workflowFormTemplate: IWorkflowFormTemplateData) =>
        workflowFormTemplate.id === payload
    );

    state.workflowFormTemplates.splice(index, 1);
  },

  SET_LAST_CREATED_WORKFLOW_FORM_TEMPLATE_ID(
    state: IWorkflowFormTemplateState,
    payload: number
  ): void {
    state.lastCreatedWorkflowFormTemplateId = payload;
  },

  SET_LAST_CREATED_WORKFLOW_FORM_TEMPLATE_REVISION_ID(
    state: IWorkflowFormTemplateState,
    payload: number
  ): void {
    state.lastCreatedWorkflowFormTemplateRevisionId = payload;
  },

  SET_WORKFLOW_FORM_TEMPLATE_REVISIONS(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormTemplateRevisionData[]
  ): void {
    state.workflowFormTemplateRevisions = payload;
  },

  ADD_WORKFLOW_FORM_TEMPLATE_REVISION(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormTemplateRevisionData
  ): void {
    state.workflowFormTemplateRevisions.push(payload);
  },

  UPDATE_WORKFLOW_FORM_TEMPLATE_REVISION(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormTemplateRevisionData
  ): void {
    const index = state.workflowFormTemplateRevisions.findIndex(
      (workflowFormTemplateRevision: IWorkflowFormTemplateRevisionData) =>
        workflowFormTemplateRevision.id === payload.id
    );

    state.workflowFormTemplateRevisions.splice(index, 1, payload);
  },

  REMOVE_WORKFLOW_FORM_TEMPLATE_REVISION(
    state: IWorkflowFormTemplateState,
    payload: number
  ): void {
    const index = state.workflowFormTemplateRevisions.findIndex(
      (workflowFormTemplateRevision: IWorkflowFormTemplateRevisionData) =>
        workflowFormTemplateRevision.id === payload
    );

    state.workflowFormTemplateRevisions.splice(index, 1);
  },

  //fields
  SET_WORKFLOW_FORM_FIELDS(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldData[]
  ): void {
    state.formFields = payload;
  },
  ADD_WORKFLOW_FORM_FIELD(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldData
  ): void {
    state.formFields.push(payload);
  },
  UPDATE_WORKFLOW_FORM_FIELD(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldData
  ): void {
    const index = state.formFields.findIndex(
      (workflowFormTemplateRevision: IWorkflowFormFieldData) =>
        workflowFormTemplateRevision.id === payload.id
    );

    state.formFields.splice(index, 1, payload);
  },
  REMOVE_WORKFLOW_FORM_FIELD(
    state: IWorkflowFormTemplateState,
    payload: number
  ): void {
    const index = state.formFields.findIndex(
      (workflowFormTemplateRevision: IWorkflowFormFieldData) =>
        workflowFormTemplateRevision.id === payload
    );

    state.formFields.splice(index, 1);
  },

  //TODO
  SET_WORKFLOW_FORM_FIELD_OPTION_TODOS(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldOptionTodoData[]
  ): void {
    state.formFieldOptionTodos = payload;
  },
  ADD_WORKFLOW_FORM_FIELD_OPTION_TODO(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldOptionTodoData
  ): void {
    state.formFieldOptionTodos.push(payload);
  },
  UPDATE_WORKFLOW_FORM_FIELD_OPTION_TODO(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldOptionTodoData
  ): void {
    const index = state.formFieldOptionTodos.findIndex(
      (workflowFormTemplateRevision: IWorkflowFormFieldOptionTodoData) =>
        workflowFormTemplateRevision.id === payload.id
    );

    state.formFieldOptionTodos.splice(index, 1, payload);
  },
  REMOVE_WORKFLOW_FORM_FIELD_OPTION_TODO(
    state: IWorkflowFormTemplateState,
    payload: number
  ): void {
    const index = state.formFieldOptionTodos.findIndex(
      (workflowFormTemplateRevision: IWorkflowFormFieldOptionTodoData) =>
        workflowFormTemplateRevision.id === payload
    );

    state.formFieldOptionTodos.splice(index, 1);
  },

  //todo-templates
  SET_WORKFLOW_FORM_TODO_TEMPLATES(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldOptionTodoTemplateData[]
  ): void {
    state.formTodoTempates = payload;
  },

  ADD_WORKFLOW_FORM_TODO_TEMPLATE(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldOptionTodoTemplateData
  ): void {
    state.formTodoTempates.push(payload);
  },

  UPDATE_WORKFLOW_FORM_TODO_TEMPLATE(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowFormFieldOptionTodoTemplateData
  ): void {
    const index = state.formTodoTempates.findIndex(
      (formTodo: IWorkflowFormFieldOptionTodoTemplateData) =>
        formTodo.id === payload.id
    );

    state.formTodoTempates.splice(index, 1, payload);
  },

  REMOVE_WORKFLOW_FORM_TODO_TEMPLATE(
    state: IWorkflowFormTemplateState,
    payload: number
  ): void {
    const index = state.formTodoTempates.findIndex(
      (formTodo: IWorkflowFormFieldOptionTodoTemplateData) =>
        formTodo.id === payload
    );

    state.formTodoTempates.splice(index, 1);
  },

  SET_TEMPLATE_WORKFLOW_STATES(
    state: IWorkflowFormTemplateState,
    payload: IWorkflowStateData[]
  ): void {
    state.templateWorkflowStates = payload;
  },

  SET_WORKFLOW_TEMPLATE_USERS(
    state: IWorkflowFormTemplateState,
    payload: IUserData[]
  ): void {
    state.workflowTemplateUsers = payload;
  }
};
